import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#FF1B49', // vermelho
        //secondary: '#A68D79', // marrom claro
      //   accent: '#00F39A',
        // info: '#5B5C79',
        tertiary: 'F2F3F5'
      },
      dark: {
        primary: '#FF1B49', // vermelho
        //secondary: '#B84265', // laranja gass
        // accent: '#00F39A', // light green
      }
    },
  },
});
